<template>
    <transition name="modal-fade">
        <div class="modal-back">
            <div class="modal-backdrop">
                <div
                    class="modal"
                    role="dialog"
                    aria-labelledby="modalTitle"
                    aria-describedby="modalDescription"
                >
                    <header class="modal-header" id="modalTitle">
                        <slot name="header">
                            <h2>What is your grade?</h2>

                            <button
                                type="button"
                                class="btn-close d-none"
                                @click="close"
                                aria-label="Close modal"
                                style="visibility: hidden;"
                            >
                                x
                            </button>
                        </slot>
                    </header>
                    <section class="modal-body" id="modalDescription">
                        <slot name="body">
                            <form id="radio_group">
                                <div class="row mb-2">
                                    <div
                                        class="col-3 my-2"
                                        v-for="grade of grades"
                                        :key="grade.id"
                                        @click="onRadioChange(grade.id)"
                                    >
                                        <div class="radio-toolbar">
                                            <input
                                                type="radio"
                                                class="form-check-input"
                                                id=""
                                                name=""
                                                :value="grade.id"
                                                :checked="grade.id === selectedRadio"
                                            />
                                            <label
                                                class="form-check-label"
                                                for="materialGroupExample1n"
                                                ><i class="fa fa-check"></i>&nbsp;Grade
                                                {{ grade.grade }}</label
                                            >
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </slot>
                    </section>
                    <footer class="modal-footer">
                        <slot name="footer">
                            <button
                                type="button"
                                class="btn-green"
                                @click="onNext"
                                aria-label="Close modal"
                                style="
                margin-right: 50px;
                width: 100px;
                height: 30px;
                font-size: 15px;
              "
                            >
                                Next
                            </button>
                        </slot>
                    </footer>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
// import $ from "jquery"
import { HTTP, getAuthorizationHeader } from "../_helper/http-constants"

export default {
    name: "modal",
    data() {
        return {
            selectedRadio: "",
            grades: [],
        }
    },
    async mounted() {
        await this.fetchGrades()
    },
    methods: {
        async fetchGrades() {
            try {
                const res = await HTTP.get("/grades?withSubjects=true", {
                    headers: getAuthorizationHeader(),
                })
                console.log("grades", res.data.result)
                this.grades = res.data.result
                this.selectedRadio = this.grades[0].id
            } catch (err) {
                console.log("error in fetching grades", err)
            }
        },
        onNext() {
            var _vm = this
            let user = JSON.parse(localStorage.getItem("user"))
            console.log("selected radio", this.selectedRadio)
            HTTP.post("/users/update", {
                email: user.email,
                grade: this.selectedRadio,
            }).then(() => {
                // populate the selected with the proper data.
                user.grade = this.grades.find((item) => this.selectedRadio === item._id)
                window.localStorage.setItem("user", JSON.stringify(user))
                const grade = this.grades.find((item) => item.id === _vm.selectedRadio)
                console.log("found grade", grade)
                _vm.$emit("close", grade)
            })
        },
        close() {},
        onRadioChange(radioVal) {
            console.log("radio change", radioVal)
            // let radioVal = $("input[name=groupOfMaterialRadios]:checked", "#radio_group").val()
            this.selectedRadio = radioVal
        },
    },
}
</script>

<style scoped>
.modal-backdrop {
    position: fixed;
    top: 20vw;
    bottom: 0;
    left: 20vw;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60vw;
    height: 60vh;
    background-color: unset !important;
}

.modal-back {
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.4);
}

.modal {
    background: #ffffff;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    width: 60%;
    height: 60%;
    top: 20%;
    left: 20%;
    box-shadow: unset !important;
}

.modal-header,
.modal-footer {
    padding: 15px;
    display: flex;
}

.modal-header {
    border-bottom: 1px solid #eeeeee;
    color: #4aae9b;
    justify-content: space-between;
}

.modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
}

.modal-body {
    position: relative;
    padding: 20px 10px;
}

.btn-close {
    border: none;
    font-size: 20px;
    padding: 20px;
    cursor: pointer;
    font-weight: bold;
    color: #4aae9b;
    background: transparent;
}

.btn-green {
    color: white;
    background: #4aae9b;
    border: 1px solid #4aae9b;
    border-radius: 2px;
}
</style>
